import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

import { CANVAS_SIZES } from "@v2/utils/canvas-size";
// eslint-disable-next-line replo/no-zustand-create-or-usestore -- needs create()() for persist middleware
import { create } from "zustand";
import { persist } from "zustand/middleware";

type ViewportMode = "preset" | "responsive";

interface ViewportStore {
  currentViewport: EditorCanvas;
  viewportMode: ViewportMode;
  customWidth: number | null;
  customHeight: number | null;
  setCustomDimensions: (dimensions: {
    width: number | null;
    height: number | null;
  }) => void;
  applyPreset: (viewport: EditorCanvas) => void;
  setResponsive: () => void;
}

export const useViewportStore = create<ViewportStore>()(
  persist(
    (set) => ({
      currentViewport: "desktop",
      viewportMode: "responsive",
      customWidth: null,
      customHeight: null,
      setCustomDimensions: ({ width, height }) => {
        return set({
          customWidth: width,
          customHeight: height,
        });
      },
      applyPreset: (viewport) => {
        return set({
          currentViewport: viewport,
          viewportMode: "preset",
          customWidth: CANVAS_SIZES[viewport].defaultFrameWidth,
          customHeight: null,
        });
      },
      setResponsive: () => {
        return set({
          viewportMode: "responsive",
          customWidth: null,
          customHeight: null,
        });
      },
    }),
    {
      name: "replo-editor-viewport",
    },
  ),
);
